import { $http } from "../request"
import domain from '../../server-config/domain.config'

// 评论token
const getHeaders =  () => ({ Authorization: useCookie<IUserInfo>('UserInfo')?.value?.accessToken || '' })

export interface IReviewPayload {
  pageNo: number,
  pageSize: number,
  queryType: number | string
}

export interface IReviewsListTab {
  listing_id: number,
  offset: number,
  limit: number,
  order_by?: 'normal' | 'latest' | 'top', // normal，latest, top(top tree)
  product_score?: number,
  has_text?: boolean,
  has_image_or_video?: boolean,
  source_type?: number
}

export interface IReviewPage {
  offset: number,
  limit: number,
  [key: string]: any
}

export const getCommentListPublicInfo = (listingId: string) =>
  $http.get({
    url: `/listing-comment-statistics/${listingId}`,
    loading: true
  }).then((r: any) => r?.data)

export const getCommentList = (params: IReviewsListTab, loading:boolean = false, isServer: boolean = false) =>
  $http.get({
    url: `/comments`,
    params,
    loading
  }).then((r: any) => r?.data)

export const getCommentReplyList = (commentId: string, params:IReviewPage) =>
  $http.get({
    url: `/comments/${commentId}/replies`,
    params,
    loading: true
  }).then((r: any) => r?.data)

export const getCommentDetail = (commentId: string) => 
  $http.get({
    url: `/comments/${commentId}`,
    loading: true
  }).then((r: any) => r?.data)

export interface IReplyParams {
  content: string,
  images: string[],
  videos: string[],
  recipient_id: number,
  parent_id: string,
}
export const submitReviewReply = (params: IReplyParams, commentId: string) => $http.post({
  url: `/comments/${commentId}/replies`,
  body: params
}).then((r: any) => r.data)
 
export const submitFavour = (
  contentsId: string
) => $http.post({
  url: `/comments/likes`,
  body: { comment_content_id: contentsId }
}).then((r: any) => r.data)

export const getAccountReviews = (limit: number, skip: number) => 
  $http.get({ url: '/account/reviews', params: { limit, skip } })
    .then((r: any) => r.data)

export const getAccountNoReviews = (limit: number, skip: number) => 
  $http.get({ url: '/account/no-review-skus', params: { limit, skip } })
    .then((r: any) => r.data)

export interface IUploadFile {
  /**
   * 文件大小：单位-MB
   */
  file_size: number;
  /**
   * 文件类型：'1'-image,'2'-video,'3'-text
   */
  file_type: '1' | '2' | '3';
  /**
   * 文件名称
   */
  filename: string;
  /**
   * 上传模块名称：review,talk,after-sale,review-video
   */
  service_name: 'review' | 'talk' | 'after-sale' | 'review-video' | 'user-info'
}
export const uploadAttach = (params: IUploadFile) => {
  const formData  =new FormData()

  for(let k in params) {
    const val = params[k as keyof IUploadFile]
    formData.append(k, String(val))
  }

  return $http.post({
    url: `/upload-file-service`,
    body: formData
  }).then((r: any) => r.data)
}

export const uploadFileByUrl = (url: string, file: File) => {
  return $http.put({
    url,
    body: file,
    headers: {
      'content-type': file.type
    } 
  })
}

export interface IAddGoodsReview {
  sale_order_id: number,
  comments: Array<IAddGoodsReviewComment>
}
export interface IAddGoodsReviewComment {
  sale_order_detail_id: number,
  product_score: number,
  service_score: number,
  logistics_score: number,
  is_anonymous: boolean,
  content?: string,
  images: string[],
  videos: string[]
}
export const publishReview = (params: IAddGoodsReview) => $http.post({ url: '/comments', body: params, loading: true })

export const getReiViews = () => $http.get({ url: '/rewards-node/reiviews' })

export const getCommentStatistics = (
  params: { listingId?: number, storeId: number },
  server: boolean = false
) => {
  const queryParams = Object.keys(params).map(k => `${k}=${params[k as keyof typeof params]}`).join('&')
  
  return $http.get({ url: `/api/comment-statistics?${queryParams}`, baseURL: '/', server }).then((r: any) => r?.data)
}